<template>
    <div class="row m-0 p-2 pt-5 services-settings-layout">
        <aside class="col-12 col-lg-3 col-xl-2 pe-lg-0 services-settings-nav">
            <div v-for="group in visibleNavigationGroups" :key="group.title" class="services-settings-nav__group">
                <div class="services-settings-nav__title">{{ group.title }}</div>
                <router-link
                    v-for="entry in group.entries"
                    :key="entry.to.name"
                    :to="entry.to"
                    class="services-settings-nav__item"
                    :exact="entry.exactUrlMatching">
                    <span>{{ entry.title }}</span>
                </router-link>
            </div>
        </aside>
        <router-view class="col-12 col-lg-9 col-xl-10 ps-lg-4 services-settings-content" />
    </div>
</template>

<script>
export default {
    name: "Services",
    computed: {
        restaurant_id() {
            return this.$route.params.restaurant_id;
        },
        rights() {
            return this.$store.getters["users/formattedRights"];
        },
        navigationGroups() {
            return [
                {
                    title: "Services",
                    entries: [
                        {
                            to: { name: "booking.restaurants.settings.services", params: { restaurant_id: this.restaurant_id } },
                            title: this.$tl("labels.routes.booking.services.current", this.restaurant_id),
                            exactUrlMatching: true,
                            rights: ["booking.service.*"],
                        },
                        {
                            to: { name: "booking.restaurants.settings.openings", params: { restaurant_id: this.restaurant_id } },
                            title: this.$tl("labels.routes.booking.services.special"),
                            exactUrlMatching: false,
                            rights: ["booking.service.*"],
                        },
                        {
                            to: { name: "booking.restaurants.settings.closures", params: { restaurant_id: this.restaurant_id } },
                            title: this.$tl("labels.routes.booking.services.closures"),
                            exactUrlMatching: false,
                            rights: ["booking.service.*"],
                        },
                    ],
                },
                {
                    title: "Menus et options",
                    entries: [
                        {
                            to: { name: "booking.restaurants.settings.menus", params: { restaurant_id: this.restaurant_id } },
                            title: this.$tl("labels.routes.booking.services.menus", this.restaurant_id),
                            exactUrlMatching: false,
                            rights: ["booking.menu.*"],
                        },
                        {
                            to: {
                                name: "booking.restaurants.settings.menus_options",
                                params: { restaurant_id: this.restaurant_id },
                            },
                            title: this.$tl("labels.routes.booking.services.menusOptions", this.restaurant_id),
                            exactUrlMatching: false,
                            rights: ["booking.menu.*"],
                        },
                    ],
                },
            ];
        },
        visibleNavigationGroups() {
            return this.navigationGroups
                .map((group) => ({
                    ...group,
                    entries: group.entries.filter((entry) => this.hasRights(entry.rights)),
                }))
                .filter((group) => group.entries.length > 0);
        },
    },
    methods: {
        hasRights(entryRights) {
            if (!entryRights || entryRights.includes("any")) return true;

            return entryRights.some((right) => {
                if (this.rights.includes(right)) return true;
                const wildcardPosition = right.indexOf("*");
                if (wildcardPosition === -1) return false;

                const prefix = right.substring(0, wildcardPosition).replace(/([.?*+^$[\]\\(){}|-])/g, "\\$1");
                return this.rights.some((currentRight) => currentRight.match(new RegExp(`${prefix}.+`, "g")));
            });
        },
    },
};
</script>
